import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsLoggerPluginModule } from '@ngxs/logger-plugin';
import { NgxsSelectSnapshotModule } from '@ngxs-labs/select-snapshot';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { PortalModule } from '@angular/cdk/portal';
import { ClickOutsideModule } from 'ng-click-outside';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';

import { UserState } from './store/user/user.state';
import { BotState } from './store/bot/bot.state';

import { HintState } from './store/hint/hint.state';

import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { GenericPopupComponent } from './layout/generic-popup/generic-popup.component';
import { FacebookModule } from 'ngx-facebook';
import { ConnectionsState } from './store/bot-connections';

// Test import
// import { PortalState } from './store/portal/portal.state';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { ExpressionService } from '../features/bot/modules/bot-learning/services/expression.service';
import { environment } from '../../environments/environment';
import { IntentService } from '../features/bot/modules/bot-learning/services/intent.service';
import { DatePipe } from '@angular/common';
import { EnvironmentGuard } from './guards/environment.guard';
import { DesktopLayoutComponent } from './layout/desktop-layout/desktop-layout.component';
import { MobileLayoutComponent } from './layout/mobile-layout/mobile-layout.component';
import { AuthGuard } from './guards/auth.guard';

@NgModule({
  declarations: [
    MainLayoutComponent,
    GenericPopupComponent,
    DesktopLayoutComponent,
    MobileLayoutComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule,
    HttpClientModule,
    NgxsModule.forRoot([UserState, BotState, ConnectionsState, HintState]),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: environment.production,
    }),
    NgxsLoggerPluginModule.forRoot({ disabled: environment.production }),
    NgxsSelectSnapshotModule.forRoot(),
    NgxsFormPluginModule.forRoot(),
    PortalModule,
    ClickOutsideModule,
    FacebookModule.forRoot(),
    MatSnackBarModule,
    MatTooltipModule,
    OverlayModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
  ],
  exports: [MainLayoutComponent, GenericPopupComponent],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ExpressionService,
    IntentService,
    DatePipe,
    EnvironmentGuard,
    AuthGuard,
  ],
})
export class CoreModule {}
